import { render, staticRenderFns } from "./PostFilePreview.vue?vue&type=template&id=66c4b55d&scoped=true&"
import script from "./PostFilePreview.vue?vue&type=script&lang=ts&"
export * from "./PostFilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./PostFilePreview.vue?vue&type=style&index=0&id=66c4b55d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4b55d",
  null
  
)

export default component.exports